import RoutingPath from './routingPath';

export const navigationMenuOptions = [
  {
    title: 'Guests',
    options: [
      {
        title: 'My Favorites',
        href: RoutingPath.MY_FAVORITES,
      },
      {
        title: 'Give $20, Get $20',
        href: RoutingPath.GIVE_20_GET_20,
      },
      {
        title: 'Gift Cards',
        href: RoutingPath.GIFT_CARDS,
      },
      {
        title: 'Help',
        href: RoutingPath.HELP_PAGE,
      },
    ],
  },
  {
    title: 'Explore',
    options: [
      {
        title: 'Hotel Experiences',
        href: RoutingPath.BROWSE_HOTELS,
      },
      {
        title: 'Pool Experiences',
        href: RoutingPath.BROWSE_POOLS,
      },
      {
        title: 'Spa Experiences',
        href: RoutingPath.BROWSE_SPAS,
      },
      {
        title: 'Day Room Experiences',
        href: RoutingPath.BROWSE_DAY_ROOMS,
      },
    ],
  },
  {
    title: 'Hotel Partners',
    options: [
      {
        title: 'List My Hotel',
        href: RoutingPath.HOTEL_LISTING,
      },
      {
        title: 'Press',
        href: RoutingPath.HOTEL_PRESS,
      },
      {
        title: 'Hotel Support',
        href: RoutingPath.HOTEL_SUPPORT,
      },
    ],
  },
];
